import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { TenantUser } from '@/common/models';
import { TelstraUIVueDialog } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    TelstraUIVueDialog,
  },
})

export default class UserDetailsDeleteUserModal extends Vue {
  @Prop({ required: true }) serverError!: string;
  @Prop({ required: true }) user!: TenantUser;
  @Prop({ required: true }) isLastUser!: boolean;
  @Prop({ default: false }) isLoading!: boolean;

  showModal(): void {
    (this.$refs.modalDeleteUser as any).show();
  }

  hideModal(): void {
    (this.$refs.modalDeleteUser as any).hide();
  }

  @Emit()
  onDeleteUser(): void {
    this.$emit('deleteTenantUser');
  }
}
